import { uuid } from 'vue-uuid';
import client from '@/axios/client';

const slydepostStoreModule = {
  state: {
    slydeposts: [],
    endOfNewsfeedReached: false,
    loadingSlydeposts: false,
  },
  getters: {
    getLoadingSlydeposts(state) {
      return state.loadingSlydeposts;
    },
    getEndOfNewsfeedReached(state) {
      return state.endOfNewsfeedReached;
    },
    getNewsfeedSlydeposts(state) {
      return state.slydeposts.map((slydepost) => {
        // Check if there are comments to sort
        if (slydepost.comments) {
          let commentsCopy = [...slydepost.comments];

          // Filter and sort parent comments
          commentsCopy = commentsCopy
            .filter((comment) => !comment.parentId)
            .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

          // Sort child comments for each parent comment
          commentsCopy.forEach((parentComment) => {
            if (parentComment.childComments) {
              parentComment.childComments.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
            }
          });

          // Return a new object to ensure the state is not mutated
          return {
            ...slydepost,
            comments: commentsCopy,
          };
        }

        // Return the post as is if there are no comments to sort
        return slydepost;
      });
    },
  },
  mutations: {
    setLoadingSlydeposts(state, loading) {
      state.loadingSlydeposts = loading;
    },
    setEndOfNewsfeedReached(state, end) {
      state.endOfNewsfeedReached = end;
    },
    deleteSlydepost(state, postId) {
      state.slydeposts = state.slydeposts.filter((obj) => obj.id !== postId);
    },
    removeLikeFromSlydepostFromNewsfeedPost(state, payload) {
      const postId = payload.postId;
      const likeId = payload.id;
      const slydepost = state.slydeposts.find((item) => item.id === postId);
      const objWithIdIndex = slydepost.likes.findIndex((obj) => obj.id === likeId);
      if (objWithIdIndex > -1) {
        slydepost.likes.splice(objWithIdIndex, 1);
      }
    },
    likeSlydepostFromNewsfeedPost(state, payload) {
      const postId = payload.postId;
      const slydepost = state.slydeposts.find((item) => item.id === postId);
      if (slydepost.likes == null) {
        slydepost.likes = [];
      }
      slydepost.likes.push(payload);
    },
    removeLikeReplyFromNewsfeedPost(state, payload) {
      const likeId = payload.id;
      const parentId = payload.parentId;
      const commentId = payload.commentId;
      const postId = payload.postId;
      const slydepost = state.slydeposts.find((item) => item.id === postId);
      const comment = slydepost.comments.find((item) => item.id === parentId);
      const childComment = comment.childComments.find((item) => item.id === commentId);
      const objWithIdIndex = childComment.likes.findIndex((obj) => obj.id === likeId);
      if (objWithIdIndex > -1) {
        childComment.likes.splice(objWithIdIndex, 1);
      }
    },
    likeReplyFromNewsfeedPost(state, payload) {
      const commentId = payload.commentId;
      const parentId = payload.parentId;
      const postId = payload.postId;
      const likeId = payload.id;
      const userId = payload.userId;
      const likePayload = {
        id: likeId,
        commentId: commentId,
        userId: userId,
      };
      const slydepost = state.slydeposts.find((item) => item.id === postId);
      const comment = slydepost.comments.find((item) => item.id === parentId);
      const childComment = comment.childComments.find((item) => item.id === commentId);
      if (childComment.likes == null) {
        childComment.likes = [];
      }
      childComment.likes.push(likePayload);
    },
    removeReplyFromCommentFromNewsfeedPost(state, payload) {
      const commentId = payload.commentId;
      const parentId = payload.parentId;
      const postId = payload.postId;

      const slydepost = state.slydeposts.find((item) => item.id === postId);
      const comment = slydepost.comments.find((item) => item.id === parentId);
      const objWithIdIndex = comment.childComments.findIndex((obj) => obj.id === commentId);
      if (objWithIdIndex > -1) {
        comment.childComments.splice(objWithIdIndex, 1);
      }
    },
    replyToCommentFromNewsfeedPost(state, payload) {
      const postId = payload.postId;
      const parentCommentId = payload.parentId;

      const slydepost = state.slydeposts.find((item) => item.id === postId);
      const comment = slydepost.comments.find((item) => item.id === parentCommentId);
      if (comment.childComments == null) {
        comment.childComments = [];
      }
      comment.childComments.push(payload);
    },
    removeLikeCommentFromNewsfeedPost(state, payload) {
      const likeId = payload.likeId;
      const commentId = payload.commentId;
      const postId = payload.postId;

      const slydepost = state.slydeposts.find((item) => item.id === postId);
      const comment = slydepost.comments.find((item) => item.id === commentId);
      const objWithIdIndex = comment.likes.findIndex((obj) => obj.id === likeId);
      if (objWithIdIndex > -1) {
        comment.likes.splice(objWithIdIndex, 1);
      }
    },
    likeCommentFromNewsfeedPost(state, payload) {
      const postId = payload.postId;
      const commentId = payload.commentId;

      const slydepost = state.slydeposts.find((item) => item.id === postId);

      if(slydepost == null || slydepost.comments == null){
        return;
      }

      const comment = slydepost.comments.find((item) => item.id === commentId);
      if (comment.likes == null) {
        comment.likes = [];
      }
      comment.likes.push(payload);
    },
    removeComment(state, payload) {
      const commentId = payload.commentId;
      const postId = payload.postId;
      const slydepost = state.slydeposts.find((item) => item.id === postId);
      const objWithIdIndex = slydepost.comments.findIndex((obj) => obj.id === commentId);
      if (objWithIdIndex > -1) {
        slydepost.comments.splice(objWithIdIndex, 1);
      }
    },
    addComment(state, payload) {
      const comment = payload.comment;
      const postId = payload.postId;
      const slydepost = state.slydeposts.find((item) => item.id === postId);
      if (slydepost.comments == null) {
        slydepost.comments = [];
      }
      slydepost.comments.push(comment);
    },
    updateNewsfeedFilter(state) {
      state.slydeposts = [];
      state.endOfNewsfeedReached = false;
    },
    addNewSlydepost(state, payload) {
      state.slydeposts.splice(0, 0, payload);
    },
    removeSlydepost(state, postId) {
      for (let i = 0; i < state.slydeposts.length; i++) {
        if (state.slydeposts[i].id === postId) {
          state.slydeposts.splice(i, 1);
        }
      }
    },
    addLoadedSlydepost(state, payload) {
      state.slydeposts.push(payload);
    },
    replaceSlydepost(state, payload) {
      for (let i = 0; i < state.slydeposts.length; i++) {
        if (state.slydeposts[i].id === payload.postId) {
          let comments = state.slydeposts[i].comments;
          let likes = state.slydeposts[i].likes;
          payload.comments = comments;
          payload.likes = likes;
          state.slydeposts.splice(i, 1, payload);
        }
      }
    },
    signOutSlydeposts(state) {
      state.slydeposts = [];
      state.postsByLoggedInUser = [];
      state.endOfNewsfeedReached = false;
    },
    clear(state) {
      state.slydeposts = [];
      state.endOfNewsfeedReached = false;
      state.loadingSlydeposts = false;
    },
  },
  actions: {
    async loadMoreSlydeposts(state, payload) {
      if (state.getters['getEndOfNewsfeedReached'] || state.getters['getLoadingSlydeposts'] === true) {
        return;
      }
      state.commit('setLoadingSlydeposts', true);
      const loggedInUserId = payload.userId;
      const newsfeedFilter = payload.filter;
      const userId = payload.userId;
      const index = payload.index;
      await client
        .get(`/post/newsfeed/${userId}?filter=${newsfeedFilter}`, {
          withCredentials: true,
          headers: {
            'request-id': uuid.v1(),
            'User-Id': loggedInUserId,
          },
          params: { index: index },
        })
        .then((response) => {
          if (response.data.length === 0) {
            state.commit('setEndOfNewsfeedReached', true);
          }
          for (let i = 0; i < response.data.length; i++) {
            state.commit('addLoadedSlydepost', response.data[i]);
          }
          state.commit('setLoadingSlydeposts', false);
        })
        .catch((error) => {});
    },
    async deleteSlydepost(state, payload) {
      const userId = payload.userId;
      const postId = payload.postId;
      state.commit('removeSlydepost', postId);
      state.commit('removePostFromPublicUserProfile', postId);
      const loggedInUserId = payload.userId;
      client
        .delete(`/post/${postId}`, {
          withCredentials: true,
          headers: {
            'User-Id': loggedInUserId,
            'request-id': uuid.v1(),
          },
        })
        .then((response) => {
          gtag('event', 'slydepost-deleted', {
            event_category: 'Slydepost',
            event_label: 'Label',
            value: 1,
          });
        })
        .catch((error) => {
          console.error(`Failed call to delete slydepost. Response: ${error.message}`);
        });
    },
  },
};

function getFileType(file) {
  if (file.type.match('image.*')) return 'IMAGE';
  if (file.type.match('video.*')) return 'VIDEO';
}

// export the entire module
export { slydepostStoreModule };
